// Control de actualizaciones de la PWA: detecta versión nueva en espera y permite aplicarla cuando el usuario quiera.
const listeners = new Set();
let waitingWorker = null;
let registration = null;

export function onUpdateAvailable(cb) { listeners.add(cb); if (waitingWorker) cb(true); return () => listeners.delete(cb); }
export const updateAvailable = () => !!waitingWorker;

function announce(sw) { waitingWorker = sw; listeners.forEach((cb) => { try { cb(true); } catch { /* noop */ } }); }

export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", async () => {
    try {
      registration = await navigator.serviceWorker.register("/sw.js");
      if (registration.waiting && navigator.serviceWorker.controller) announce(registration.waiting);
      registration.addEventListener("updatefound", () => {
        const nw = registration.installing;
        if (!nw) return;
        nw.addEventListener("statechange", () => {
          if (nw.state === "installed" && navigator.serviceWorker.controller) announce(nw);
        });
      });
      // Buscar actualizaciones cada 10 min y al volver a la ventana
      setInterval(() => registration.update().catch(() => {}), 10 * 60 * 1000);
      document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") registration.update().catch(() => {}); });
    } catch (e) { console.warn("SW registro falló:", e); }
  });
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing || !waitingWorker) return; // solo recarga cuando el usuario aplicó la actualización
    refreshing = true; window.location.reload();
  });
}

export function applyUpdate() {
  if (waitingWorker) { waitingWorker.postMessage({ type: "SKIP_WAITING" }); return true; }
  window.location.reload(); return false;
}

export function checkForUpdate() { return registration ? registration.update().catch(() => {}) : Promise.resolve(); }
